// extracted by mini-css-extract-plugin
export default {"wrapper":"text__wrapper__d19kC","title":"text__title__sRGk5","body":"text__body__MQXSq","img":"text__img__WGPEs"};